"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { catchError, type ErrorInfo } from "next/error";
import { DreamMuiHandledErrorRefresh } from "./ui-elements/Mui/DreamMuiHandledError";

type RecoveryOptions = { homeHref?: string };

export function DreamRecoverableError({
  error,
  retry,
  homeHref,
}: Pick<ErrorInfo, "error" | "retry"> & RecoveryOptions) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <DreamMuiHandledErrorRefresh
      title="We're sorry, something went wrong"
      content="Try again to reload this content. If the problem continues, refresh the page or contact us for help."
      onRetry={retry}
      homeHref={homeHref}
    />
  );
}

// Keep the surrounding portal shell mounted while Next.js retries the failed content.
export const DreamRecoverableErrorBoundary = catchError(function RecoverableErrorFallback(
  props: RecoveryOptions,
  errorInfo: ErrorInfo
) {
  return <DreamRecoverableError {...props} {...errorInfo} />;
});
